import React, {ChangeEvent, FC, useEffect, useRef, useState} from 'react';
import s from './PromptBlock.module.css';
import CardItem from "../../../onboarding-page/entities/card-item/CardItem";
import { useSelector } from "react-redux";
import {selectCurrentProject, selectCurrentStep} from "../../../../store/selectors/projectSelectors";
import {generateScript, setCurrentProject, setCurrentStep, updateProject} from "../../../../store/slices/projectSlice";
import { useAppDispatch } from "../../../../store/store";
import Button from "../../../../shared/ui/button/Button";
import spark from '../../../../assets/img/spark.svg'

import {useDebounce} from "../../../../shared/hooks/useDebounce";
import shape1 from "../../../../assets/img/shape1.svg";
import shape2 from "../../../../assets/img/shape2.svg";
import shape3 from "../../../../assets/img/shape3.svg";
import shape4 from "../../../../assets/img/shape4.svg";
import shape5 from "../../../../assets/img/shape5.svg";
import shape6 from "../../../../assets/img/shape6.svg";
import shape7 from "../../../../assets/img/shape7.svg";
import shape8 from "../../../../assets/img/shape8.svg";
import shape9 from "../../../../assets/img/shape9.svg";
interface Option {
    text: string;
    isActive: boolean;
    tag:string;
    color?: string;
}

interface PromptBlockConfig {
    header: string;
    description?: string;
    content: 'textarea' | 'options';
    options?: Option[];
}

export const promptBlockTypes: Record<string, PromptBlockConfig> = {
    overall: {
        header: 'What do you want to post about?',

        content: 'textarea',
    },
    voice: {
        header: 'Make it unique!',
        description: 'Let’s shape your signature brand voice!',
        content: 'options',
        options: [
            { text: 'Good times', isActive: false, tag: 'good-times', color: '#FFD700' },
            { text: 'Hustle', isActive: false, tag: 'hustle', color: '#FF4500' },
            { text: 'Glow-up', isActive: false, tag: 'glow-up', color: '#32CD32' },
            { text: 'Dreams', isActive: false, tag: 'dreams', color: '#87CEEB' },
            { text: 'Hype', isActive: false, tag: 'hype', color: '#FF69B4' },
            { text: 'Pride', isActive: false, tag: 'pride', color: '#8A2BE2' },
            { text: 'Solid', isActive: false, tag: 'solid', color: '#A9A9A9' },
            { text: 'Pro-tip', isActive: false, tag: 'pro-tip', color: '#1E90FF' },
            { text: 'Support', isActive: false, tag: 'support', color: '#FFDAB9' },
        ]},
    tone: {
        header: 'Adjust the Tone & Style!',
        description: 'Choose how you want to wrap up your content!',
        content: 'options',
        options: [
            { text: 'Friendly', isActive: false, tag: 'entertaining', color: '#FFFF01' },
            { text: 'Exciting', isActive: false, tag: 'exciting', color: '#FABC1E'},
            { text: 'Fun', isActive: false, tag: 'fun', color: '#43FEAF'},
            { text: 'Serious', isActive: false, tag: 'serious', color: '#68C0FF'},
            { text: 'Witty', isActive: false, tag: 'witty', color: '#ECEC41'},
            { text: 'Persuasive', isActive: false, tag: 'persuasive', color: '#FF7051'},
            { text: 'Neutral', isActive: false, tag: 'neutral', color: '#F8C9FC'},
            { text: 'Emotional', isActive: false, tag: 'emotional', color: '#58A0FE'},
            { text: 'Inspiring', isActive: false, tag: 'inspiring', color: '#85C9B2'},
        ]}}



interface PromptBlockProps {
    type: keyof typeof promptBlockTypes;
}
const PromptBlock: FC<PromptBlockProps> = ({ type }) => {

    const config = promptBlockTypes[type] || promptBlockTypes['overall'];
    const currentProject = useSelector(selectCurrentProject);
    const currentStep = useSelector(selectCurrentStep);
    const dispatch = useAppDispatch();
    const [goal, setGoal] = useState<string>(currentProject?.goal || "");
    const [selectedTones, setSelectedTones] = useState<string[]>(currentProject?.tone || []); // Инициализация списка тонов
    const debouncedGoal = useDebounce(goal, 1000);
    const isFirstRender = useRef(true);
    console.log(selectedTones)
    const changeGoal = (e: ChangeEvent<HTMLTextAreaElement>): void => {
        setGoal(e.target.value);
    };

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (currentProject && debouncedGoal) {
            const newData = { ...currentProject, goal: debouncedGoal };
            dispatch(setCurrentProject(newData));
            dispatch(updateProject(newData));
        }
    }, [debouncedGoal]);

    const changeVoice = (selectedTag: string): void => {
        if (currentProject) {
            const newData = { ...currentProject, voice: selectedTag };
            dispatch(updateProject(newData));
            handleGenerateScript();
        }
    };

    const changeTone = (selectedTag: string): void => {
        if (selectedTones.includes(selectedTag)) {

            const updatedTones = selectedTones.filter(tone => tone !== selectedTag);
            setSelectedTones(updatedTones);
            dispatch(updateProject({ ...currentProject, tone: updatedTones }));
            handleGenerateScript();
        } else if (selectedTones.length < 3) {
            const updatedTones = [...selectedTones, selectedTag];
            setSelectedTones(updatedTones);
            dispatch(updateProject({ ...currentProject, tone: updatedTones }));
            handleGenerateScript();
        } else {
            console.warn('Cannot select more than 3 tones');
        }
    };


    const handleGenerateScript = async () => {
        if (currentProject?.id) {
            try {
                const response = await dispatch(generateScript({ projectId: currentProject.id })).unwrap();
                if (currentStep === 4) {
                    dispatch(setCurrentStep(currentStep + 1));
                }
                console.log('Script generated successfully:', response);
            } catch (error) {
                console.error('Failed to handle generate script:', error);
            }
        }
    };

    return (
        <div className={`${s.container} ${type === 'overall' ? s.overall_container : ''}`}>
            <div className={s.inner_container}>
                <h3 className={s.title}>{config.header}</h3>
                {config.description && <p className={s.description}>{config.description}</p>}
                {config.content === 'textarea' && (
                    <textarea
                        className={s.text_input}
                        value={goal}
                        placeholder={'Write a new prompt'}
                        onChange={changeGoal}
                    />
                )}
                {config.content === 'options' && config.options && type === 'voice' && (
                    <div className={s.tone_options}>
                        {config.options.map((option, index) => (
                            <CardItem
                                key={index}
                                item={{
                                    ...option,
                                    isActive: currentProject?.voice === option.tag,
                                }}
                                onClick={() => changeVoice(option.tag)}
                                size={'small'}
                            />
                        ))}
                    </div>
                )}
                {config.content === 'options' && config.options && type === 'tone' && (
                    <div className={s.tone_options}>
                        {config.options.map((option, index) => (
                            <CardItem
                                key={index}
                                item={{
                                    ...option,
                                    isActive: selectedTones.includes(option.tag),
                                }}
                                onClick={() => changeTone(option.tag)}
                                size={'small'}
                            />
                        ))}
                    </div>
                )}
                {type === 'overall' && (
                    <div className={s.btn_container}>
                        <Button
                            onClick={handleGenerateScript}
                            style={{ height: '30px' }}
                            icon={spark}
                            iconPosition={'left'}
                            text={'Generate'}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default PromptBlock;
